import { Component } from '@angular/core';

@Component({
  selector: 'app-transit-do-payments-submit',
  templateUrl: './transit-do-payments-submit.component.html',
  styleUrls: ['./transit-do-payments-submit.component.css']
})
export class TransitDoPaymentsSubmitComponent {

}
